/* tslint:disable */
/* eslint-disable */
/**
 * Marco Email Parser API
 * Marco Email Parser API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ForYouReasonKey = {
    ChainAffinity: 'chain_affinity',
    PriceFit: 'price_fit',
    EmbeddingSimilarity: 'embedding_similarity',
    PastStayPositive: 'past_stay_positive',
    Collaborative: 'collaborative',
    LoyaltyTier: 'loyalty_tier'
} as const;
export type ForYouReasonKey = typeof ForYouReasonKey[keyof typeof ForYouReasonKey];


export function instanceOfForYouReasonKey(value: any): boolean {
    for (const key in ForYouReasonKey) {
        if (Object.prototype.hasOwnProperty.call(ForYouReasonKey, key)) {
            if (ForYouReasonKey[key as keyof typeof ForYouReasonKey] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ForYouReasonKeyFromJSON(json: any): ForYouReasonKey {
    return ForYouReasonKeyFromJSONTyped(json, false);
}

export function ForYouReasonKeyFromJSONTyped(json: any, ignoreDiscriminator: boolean): ForYouReasonKey {
    return json as ForYouReasonKey;
}

export function ForYouReasonKeyToJSON(value?: ForYouReasonKey | null): any {
    return value as any;
}

export function ForYouReasonKeyToJSONTyped(value: any, ignoreDiscriminator: boolean): ForYouReasonKey {
    return value as ForYouReasonKey;
}

